import { Response } from "@/models/continente-credentials/common/Response";
import { CardAssociation } from "@/models/continente-credentials/mobile/CardAssociation";
import { CardAssociationResponse } from "@/models/continente-credentials/mobile/CardAssociationResponse";
import { LoyaltyCardOtpValidationResponse } from "@/models/continente-credentials/loyaltycard/LoyaltyCardOtpValidationResponse";

export interface ICardAssociationService {
  cardAssociation(
    cardAssociation: CardAssociation,
    cardAssociationUrl: string
  ): Promise<Response<CardAssociationResponse>>;

  verifyOtp(
    otp: string,
    loyaltyOtpVerificationUrl: string
  ): Promise<Response<LoyaltyCardOtpValidationResponse>>;
}

export class CardAssociationService implements ICardAssociationService {
  async cardAssociation(
    cardAssociation: CardAssociation,
    cardAssociationUrl: string
  ): Promise<Response<CardAssociationResponse>> {
    const resp = await fetch(cardAssociationUrl, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cardAssociation),
    });

    if (resp.ok) {
      return { kind: "success", value: await resp.json() };
    } else if (resp.status === 400) {
      const error = await resp.json();

      const returnedError = error.find((c: any) => c.Code != null);
      return {
        kind: "error",
        code: returnedError.Code ? returnedError.Code : 0,
        message: returnedError.message ? returnedError.message : "",
      };
    } else {
      return {
        kind: "unexpected_error",
      };
    }
  }

  async verifyOtp(
    otp: string | undefined,
    loyaltyOtpVerificationUrl: string
  ): Promise<Response<LoyaltyCardOtpValidationResponse>> {
    const resp = await fetch(loyaltyOtpVerificationUrl, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        otp: otp,
      }),
    });

    if (resp.ok) {
      return { kind: "success", value: await resp.json() };
    } else if (resp.status === 400) {
      const error = await resp.json();

      const returnedError = error.find((c: any) => c.Code != null);
      return {
        kind: "error",
        code: returnedError.Code ? returnedError.Code : 0,
        message: returnedError.message ? returnedError.message : "",
      };
    } else {
      return {
        kind: "unexpected_error",
      };
    }
  }
}

export const cardAssociationService = new CardAssociationService();
